module.exports = __webpack_public_path__ + "common/gh-icon-favorite-d0567ffa9dac4ba75d0c3598e1525718.svg";